import { togglePosition } from '../utils';
import { BROADCAST_TOGGLE_BACKGROUND_STATUS } from 'actions/Types';

/**
 * Handles the syncing of hidden status of backgrounds through the toggling of the eye-ball icon.
 */
export default backgroundId => {
  return (dispatch, getState) => {
    const { backgrounds } = getState();
    const updatedBackgrounds = togglePosition(backgroundId, backgrounds);
    const action = {
      payload: updatedBackgrounds,
      type: BROADCAST_TOGGLE_BACKGROUND_STATUS
    };
    dispatch(action);
  };
};
